import {Grid, Slider, styled, Typography} from "@mui/material"
import React from "react"

export const StyledHorizontalSlider = styled(Slider)(({theme}) => theme.HORIZONTALSLIDER.root)
export const StyledVerticalSlider = styled(Slider)(({theme}) => theme.VERTICALSLIDER.root)

const ResponsiveSlider = ({widget, value = 0, onValueChange}) => {
    const {min = "0", max = "100", text} = widget

    return (
        <Grid container width="100%">
            <Grid display={{xs: "flex", lg: "none"}} flexDirection="column" size={12}>
                <Grid display="flex" justifyContent="space-between" alignItems="center">
                    <Typography>{text}</Typography>
                    <Typography>{value} %</Typography>
                </Grid>
                <Grid>
                    <StyledHorizontalSlider orientation="horizontal" min={Number.parseInt(min)} max={Number.parseInt(max)} value={value} onChange={(_, newval) => onValueChange(newval)} />
                </Grid>
            </Grid>
            <Grid container flexDirection="column" flexWrap="nowrap" alignItems="center" spacing={2} display={{xs: "none", lg: "flex"}} size={12}>
                <Grid>
                    <Typography>{value} %</Typography>
                </Grid>
                <Grid height="100%">
                    <StyledVerticalSlider orientation="vertical" min={Number.parseInt(min)} max={Number.parseInt(max)} value={value} onChange={(_, newval) => onValueChange(newval)} />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ResponsiveSlider